import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../ts/api/comunicacion";

export interface UseArticulosParams {
	idsFamilia: string[];
	tipo: TiposSeleccionFiltroStock;
}
export function useArticulosStock(parametros: UseArticulosParams) {
	return useQuery<ArticuloFabricacion[]>({
		queryKey: ["getArticulosStock", parametros],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<ArticuloFabricacion[]>("GET", "/api/v1/getArticulosStock", parametros);
		}
	});
}
export interface ArticuloFabricacion {
	idArticulo: number;
	referencia: string | undefined;
	nombreArticulo: string;
	nombreFamilia: string | null;
	nombreSubFamilia: string | null;
	rutaFabricacion: string | null;
	tipoArticulo: number | null;

	stock: number | null;
	pendienteEntrada: number | null;
	pendienteSalida: number | null;
	entrarRecomendado: number;
	max: number | null;
	min: number | null;
}
export type TiposSeleccionFiltroStock = [
	"todo",
	"enStock",
	"minimo",
	"maximo",
	"roturaStock",
][number];

export function useArticulos() {
	return useQuery<Articulo[]>({
		queryKey: ["getArticulos"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<Articulo[]>("GET", "/api/v1/getArticulos", {});
		}
	});
}



export interface Articulo {
	idArticulo: number;
	idFamilia: number | null;
	referencia: string;
	nombreArticulo: string;
	nombreFamilia: string | null;
	rutaFabricacion: string | null;
	tipoArticulo: number | null;
}